import React from "react";
import { Phone, PhoneCall } from "lucide-react";
import { useGet } from "../../hooks/useGet";
import Loading from "../../components/Loading";
import DashboardHeader from "../components/dashboard/DashboardHeader";
import MetricCard from "../components/dashboard/MetricCard";
import SummaryCard from "../components/dashboard/SummaryCard";

interface DashboardData {
  data: {
    total_mo: number;
    total_mt: number;
  };
}

const PlatformDashboard: React.FC = () => {
  const { data, isLoading } = useGet<DashboardData>("/dashboard", [
    "dashboard",
  ]);

  if (isLoading) {
    return <Loading />;
  }

  const totalMo = data?.data?.total_mo ?? 0;
  const totalMt = data?.data?.total_mt ?? 0;

  return (
    <div>
      <DashboardHeader />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MetricCard
          title="Total MO"
          subtitle="Mobile Originated Messages"
          value={totalMo}
          icon={Phone}
          gradientFrom="emerald-400"
          gradientTo="teal-500"
        />
        <MetricCard
          title="Total MT"
          subtitle="Mobile Terminated Messages"
          value={totalMt}
          icon={PhoneCall}
          gradientFrom="blue-400"
          gradientTo="indigo-500"
        />
      </div>
      <SummaryCard totalMo={totalMo} totalMt={totalMt} />
    </div>
  );
};

export default PlatformDashboard;
